import { WalletItemModel } from '@/services/apis/wallet/models'
import { FC, memo } from 'react'
import styles from './index.module.scss'
import { formatDayChangeRate, formatDayChangeAmount } from '@/utils/number'
import { CURRENCY } from '@/constants/index'
import { useTranslation } from '@/services/i18n'
import { formatUSD } from '@/utils/format'
import { useNavigate } from 'react-router-dom'

interface OverviewProps {
  data?: WalletItemModel
}

const Overview: FC<OverviewProps> = ({ data }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  return (
    <div className={styles.container}>
      <header>
        <h3>
          {data?.accountName}（{t('wallet.detail.assets', { currency: CURRENCY })}）
        </h3>
        <div>
          <div
            className={styles.tag}
            onClick={() =>
              navigate(
                `/history?tab=2&account=${data?.accountKey ?? ''}&accountName=${
                  data?.accountName ?? ''
                }`
              )
            }
          >
            {t('wallet.detail.signRecord')}
          </div>
          <div
            className={styles.tag}
            onClick={() =>
              navigate(
                `/history?&account=${data?.accountKey ?? ''}&accountName=${data?.accountName ?? ''}`
              )
            }
          >
            {t('wallet.detail.txRecord')}
          </div>
        </div>
      </header>
      <p>$ {formatUSD(data?.usdBalance || '0')}</p>
      <div>
        <span className={styles.label}>{t('common.today')}</span>
        <span>{formatDayChangeRate(data?.openUsdBalance, data?.usdBalance)} </span>
        <span>
          ({formatDayChangeAmount(data?.openUsdBalance, data?.usdBalance)} {CURRENCY})
        </span>
      </div>
    </div>
  )
}

export default memo(Overview)
